import { Box, Col, Container, Flex, Row, Switch, SwitchField, Text, thc } from "@flightstats/airframe-react";
import { AlertType } from "../../../types/travelerProfile";
import React from "react";
import { contactPointFormIds } from "../TravelerProfileConstants";
import { isIe11 } from "../../../service/commonFetch";

type AccordionHeadProps = {
    isDisabled: boolean;
    alertType: AlertType;
    setIsDisabled: (isDisabled: boolean) => void;
};

export const AccordionHeadWrapper = thc(Flex, {
    alignItems: 'center',
    height: '100%',
    left: '0',
    position: 'absolute',
    top: '0',
    width: '100%',
    zIndex: '2',
});

const AlertTypeWrapper = thc(Text, {
    whiteSpace: 'nowrap',
    letterSpacing: '0',
});

const SwitchWrapper = thc(
    Flex,
    {
        alignItems: 'center',
        height: '24px',
    },
    {
        '& div': {
            marginBottom: '0',
        },
        '& div[color]': {
            display: 'none',
        },
    },
);

type AlertSwitchProps = {
    isDisabled: boolean;
    setIsDisabled: (isDisabled: boolean) => void;
    alertType: AlertType;
};

export const AlertSwitch: React.FC<AlertSwitchProps> = ({
    isDisabled,
    setIsDisabled,
    alertType,
}) => {
    const idName = contactPointFormIds(alertType).sendAlerts;
    return (
        <SwitchWrapper>
          <Text inline mr={3}>
                 Off
               </Text>
               {/* this doesn't need a min-height in-page, but if you don't set one to anything from 0-16px, the switch gets offset vertically from its default location */}
               <SwitchField minHeight="16px">
                 <Switch
                   id={idName}
                   name={idName}
                   onChange={(val: boolean) => {
                     setIsDisabled(!val);
                   }}
                   on={!isDisabled}
                 />
               </SwitchField>
               <Text inline ml={3}>
                 On
               </Text>
        </SwitchWrapper>
    );
};

export const AccordionHead: React.FC<AccordionHeadProps> = ({
    isDisabled,
    alertType,
    setIsDisabled,
}) => (
     <Box width="100%" pl="2rem">
          <Container fluid>
            <Row align="center">
              <Col>
                <AlertTypeWrapper>{alertType}</AlertTypeWrapper>
              </Col>
              {!isIe11() && (
                <Col align="flex-end">
                  <AlertSwitch
                    isDisabled={isDisabled}
                    setIsDisabled={setIsDisabled}
                    alertType={alertType}
                  />
                </Col>
              )}
            </Row>
          </Container>
        </Box>
);